/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Voltar',
    CANCEL: 'Cancelar',
    CLOSE: 'Fechar',
    COLLECT: 'Recolher',
    CONFIRM: 'Confirmar',
    NEW_USER: 'Novo utilizador',
    NEXT: 'Próximo',
    SAVE: 'Guardar',
    SCAN_QR_CODE: 'Ler o QR code',
    SWIPE_DOWN: 'Deslizar para baixo para ocultar os detalhes',
    SWIPE_UP: 'Deslizar para cima para ver os detalhes',
    WITHOUT_PIN: 'Não tens um PIN ou código QR? {link}.',
    WITHOUT_PIN_TO_COLLECT: 'Não tens um PIN? {link}.'
  },
  ERRORS: {
    INVALID_CODE: 'Código inválido.',
    INVALID_EMAIL: 'E-mail inválido.',
    INVALID_NUMBER: 'Número inválido.',
    INVALID_PHONE: 'Telefone inválido.',
    INVALID_USER: 'Utilizador inválido.',
    ORDER_DELIVER_INVALID_CODE: 'O {code} é inválido.',
    ORDER_DELIVERED: 'A encomenda já foi entregue.',
    SOMETHING_WENT_WRONG: 'Ocorreu um erro!',
    UNABLE_TO_VALIDATE: 'Não foi possível validar a encomenda.',
    VALIDATING_CODE: 'Não foi possível validar o código {code}.'
  },
  LABELS: {
    ACCEPT_RETURN: 'Tem a certeza que deseja aceitar a devolução?',
    ALL_ORDERS: 'Ver todos',
    ANOMALY: 'Anomalia?',
    CANCELED: 'Cancelada',
    CLICK_HERE: 'Clica aqui',
    CLIENT_NAME: 'Cliente',
    COLLECT_ORDER: 'Devolver encomenda',
    COLLECTS_NOT_FOUND: 'Não foram encontradas recolhas.',
    CUSTOMER_SIGNATURE: 'Assinatura do cliente',
    DATE_AND_HOUR: 'Data & Hora',
    DELIVER_ORDER: 'Entregar encomenda',
    DELIVERED: 'Entregue',
    EMAIL: 'E-mail',
    ERROR: 'Erro',
    IDENTITY_DOCUMENT: 'Documento de identificação',
    IDENTITY_NAME: 'Nome no documento de identificação',
    IDENTITY_NUMBER: 'Número do documento de identificação',
    NAME: 'Nome',
    NEW_USER: 'Novo utilizador',
    NO_USERS: 'Não existe ainda nenhum utilizador.',
    NOT_DELIVERED: 'Não entregue',
    OR: 'Ou',
    ORDER_CODE: 'Código da encomenda',
    ORDER_NUMBER: 'N.º da encomenda',
    PACKAGE_NUMBER: 'Número da caixa',
    PACKAGES: 'Caixas',
    PACKAGES_CODES: 'Códigos das caixas',
    PACKAGES_DELIVERED: 'Caixas entregues',
    PACKAGES_NUMBER: 'Nº de caixas',
    PACKAGES_RECEIVED: 'Caixas recebidas',
    PHONE: 'Telefone',
    PHONE_EXAMPLE: ', exemplo: +351999999999',
    PICK_UP_COLLECT_PIN: 'PIN de devolução',
    PICK_UP_NOT_FOUND: 'Não foi encontrado nenhum ponto de recolha.',
    PICK_UP_PIN: 'PIN de levantamento',
    PICK_UP_SEARCH: 'Procurar um ponto de recolha',
    PICK_UP_SELECT: 'Selecionar um ponto de recolha',
    PROCESSING: 'Em processamento',
    READ_CLIENT_DELIVERY_QR_CODE: 'Ler o QR code de levantamento',
    READ_PACKAGE_QR_CODE: 'Ler o QR code da caixa',
    RECEIVE_PACKAGES: 'Receber caixas',
    RECEIVED_BY: 'Quem recebeu?',
    RETURNED: 'Devolvida',
    RETURNS: 'Devoluções',
    SEARCH_FOR: 'Procurar',
    SELECT_DELIVER: 'Selecione uma encomenda para entregar',
    SHOW_ALL: 'Todos',
    SHOW_IN_TRANSIT: 'Em transito',
    SHOW_PENDING: 'Pendentes',
    STATE: 'Estado',
    SUCCESS: 'Sucesso',
    TOTAL_ORDERS: 'Pedidos',
    TOTAL_PACKAGES: 'Caixas',
    TRACKING_NUMBER: 'Nº Tracking',
    TYPE: 'Tipo',
    TYPE_COLLECT: 'Pedido de recolha',
    TYPE_DELIVERY: 'Pedido de entrega',
    USERS: 'Utilizadores',
    WARNING: 'Aviso',
    YOUR_ID: 'O teu ID: {id}'
  },
  SENTENCES: {
    COLLECT_PACKAGES: 'Caixa(s) da encomenda {trackingNumber}.',
    DELIVERED_PACKAGES:
      'Todas as caixas estão lidas da encomenda {trackingNumber}.',
    HI: '👋 Olá, {name},',
    NO_DELIVERIES: 'Não existem encomendas por entregar.',
    ORDER_TO_RETURN: 'Preencha o PIN da encomenda a devolver.',
    RECEIVED_PACKAGES: 'Todas as caixas estão recebidas.',
    UNDELIVERED_PACKAGES:
      'Existem {total} caixa(s) por ler da encomenda {trackingNumber}.',
    UNRECEIVED_PACKAGES: 'Existem {total} caixa(s) por receber.',
    WELCOME: 'Bem-vindo. O que quer fazer?',
    WELCOME_WITH_PROZIS_POINTS: 'Já ganhou {prozisPoints} ProzisPoints.',
    WITHOUT_SERVICE_POINTS:
      'Sem pontos de serviço atribuídos. A aplicação vai fechar.'
  },
  SUCCESS: {
    CODE_READ: 'Código {code} lido com sucesso.'
  }
};
